import React, { useEffect, useState } from "react"
import clsx from "clsx"
import { getIDBValue, setIDBValue } from "../../../../utils/idbUtils"
import * as styles from "./CountDown.module.scss"
import { CountDownProps } from "../types"

export const CountDown = ({
  countDownTime = 43200000,
  backgroundColor,
  nameCountDown,
}: CountDownProps) => {
  const [time, setTime] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadCount = async () => {
      const savedCount = await getIDBValue<number>(nameCountDown)

      if (savedCount === undefined || savedCount <= 0) {
        setTime(countDownTime)
        await setIDBValue(nameCountDown, countDownTime)
      } else {
        setTime(savedCount)
      }
      setLoading(false)
    }

    loadCount()
  }, [countDownTime, nameCountDown])

  useEffect(() => {
    if (!loading && time !== null) {
      const saveCount = async () => {
        await setIDBValue(nameCountDown, time)

        if (time <= 0) {
          setTime(countDownTime)
          await setIDBValue(nameCountDown, countDownTime)
        }
      }

      saveCount()
    }
  }, [time, loading, nameCountDown, countDownTime])

  useEffect(() => {
    if (time === null || time <= 0) {
      return undefined
    }

    const timer = setInterval(() => {
      setTime((prev) => {
        if (prev === null) return null
        const newTime = prev - 1000
        return newTime >= 0 ? newTime : 0
      })
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [time])

  const formatTime = (milliseconds: number) => {
    const totalSeconds = Math.floor(milliseconds / 1000)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    return {
      minutes: minutes.toString().padStart(2, "0").split(""),
      seconds: seconds.toString().padStart(2, "0").split(""),
    }
  }

  if (time === null) {
    return null
  }

  return (
    <div className={styles.timeList}>
      <div className={styles.minutes}>
        {formatTime(time).minutes.map((item, index) => (
          <div key={`min-${index}`} className={clsx(styles.timeBlock, styles[backgroundColor])}>
            {item}
          </div>
        ))}
        <p className={styles.minutes__text}>мин</p>
      </div>
      :
      <div className={styles.minutes}>
        {formatTime(time).seconds.map((item, index) => (
          <div key={`sec-${index}`} className={clsx(styles.timeBlock, styles[backgroundColor])}>
            {item}
          </div>
        ))}
        <p className={styles.minutes__text}>сек</p>
      </div>
    </div>
  )
}
